import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0Card } from '@factorialco/f0-react'
import { ExternalLink } from '@factorialco/f0-react/icons/app'
import { UpsellLandingPage } from 'generated/resources/datatable.graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const LaunchesWithCEOPageProductUpdatesSection = ({
  content,
}: {
  content: UpsellLandingPage | undefined
}) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box className="flex flex-col items-center justify-center" gap="s40">
      <Box className="flex flex-col items-center justify-center" gap="s12">
        <Text size="500" color="black" weight="bold">
          {content?.crossSellingTitle || ''}
        </Text>
        <Text size="400">{content?.crossSellingDescription || ''}</Text>
        <F0Button
          label={i18n.t('product_updates.launches_with_ceo.product_updates.button_label')}
          variant="outline"
          onClick={() => {
            track(trackingEvents.productUpdates.clickViewAllProductUpdates, {
              source: 'launches_with_ceo_product_updates_section',
            })
            navigate(navigation.discover.productUpdates.fullPath())
          }}
          icon={ExternalLink}
        />
      </Box>
      <Box className="grid grid-cols-3 gap-4 " style={{ maxWidth: '1200px', alignSelf: 'center' }}>
        {content?.productUpdates?.map((productUpdate, index) => (
          <F0Card
            key={index}
            image={productUpdate.thumbnail?.url || ''}
            title={productUpdate.title || ''}
            description={productUpdate.shortDescription || ''}
            secondaryActions={[
              {
                label: i18n.t('product_updates.launches_with_ceo.product_updates.learn_more'),
                onClick: () => {
                  track(trackingEvents.productUpdates.clickProductUpdateCTA, {
                    source: 'launches_with_ceo_product_updates_section',
                    product_update_id: productUpdate.slug,
                  })
                  navigate(
                    navigation.discover.productUpdates.item.fullPath({ slug: productUpdate.slug })
                  )
                },
              },
            ]}
          />
        ))}
      </Box>
    </Box>
  )
}

export default LaunchesWithCEOPageProductUpdatesSection
